import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-href"]
const _hoisted_2 = ["href"]

import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FbShareButton',
  props: {
    url: {}
  },
  setup(__props: any) {



onMounted(() => {
  setTimeout(() => {
    const fbAsyncInit = (window as any).fbAsyncInit
    if (fbAsyncInit) {
      fbAsyncInit()
    }
  }, 100)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "fb-share-button",
      "data-href": __props.url,
      "data-layout": "button_count",
      "data-size": "small"
    }, [
      _createElementVNode("a", {
        target: "_blank",
        href: __props.url,
        class: "fb-xfbml-parse-ignore"
      }, "Share", 8 /* PROPS */, _hoisted_2)
    ], 8 /* PROPS */, _hoisted_1)
  ]))
}
}

})